var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-avatar',_vm._b({style:(_vm.avatarStyle),attrs:{"fit":_vm.objectFit,"src-set":_vm.srcset},on:{"error":function($event){return _vm.$emit('error')}}},'el-avatar',_vm.trimAttrs(_vm.$attrs),false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }